var _dec, _class, _descriptor, _dec2, _class3, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { Status } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/message/status';
import { captureException } from '@sentry/ember';
import Enum from '@square/dashboard-utilities/utils/enum';

// Addons
export const ADDON_INSTALL_ERROR = 'ADDON_INSTALL_ERROR';
export const ADDON_UNINSTALL_ERROR = 'ADDON_UNINSTALL_ERROR';

// Modes
export const MODE_DELETE_ERROR = 'MODE_DELETE_ERROR';
export const MODE_DUPLICATE_ERROR = 'MODE_DUPLICATE_ERROR';
export const MODE_RECOMMENDED_TEMPLATES_ERROR = 'MODE_RECOMMENDED_TEMPLATES_ERROR';
export const MODE_SEARCH_ERROR = 'MODE_SEARCH_ERROR';
export const DeviceProfileMessageStatuses = Enum.create([ADDON_INSTALL_ERROR, ADDON_UNINSTALL_ERROR, MODE_DELETE_ERROR, MODE_DUPLICATE_ERROR, MODE_RECOMMENDED_TEMPLATES_ERROR, MODE_SEARCH_ERROR, ...Object.keys(Status)]);
export const ERROR_STATUS_TRANSLATION_KEYS = {
  [DeviceProfileMessageStatuses.PROFILE_IS_LINKED]: 'business.devices.profiles.v2.errors.PROFILE_IS_LINKED',
  [DeviceProfileMessageStatuses.UNIQUENESS_ERROR]: 'business.devices.profiles.v2.errors.UNIQUENESS_ERROR',
  [DeviceProfileMessageStatuses.ERROR]: 'business.devices.profiles.v2.errors.ERROR',
  [DeviceProfileMessageStatuses.MERCHANT_MISMATCH]: 'business.devices.profiles.v2.errors.MERCHANT_MISMATCH',
  [DeviceProfileMessageStatuses.MISSING_VERSION]: 'business.devices.profiles.v2.errors.MISSING_VERSION',
  [DeviceProfileMessageStatuses.OUTDATED_VERSION]: 'business.devices.profiles.v2.errors.OUTDATED_VERSION',
  [DeviceProfileMessageStatuses.NO_PROFILE_FOUND]: 'business.devices.profiles.v2.errors.NO_PROFILE_FOUND',
  [DeviceProfileMessageStatuses.ADDON_INSTALL_ERROR]: 'business.devices.profiles.v2.errors.ADDON_INSTALL_ERROR',
  [DeviceProfileMessageStatuses.ADDON_UNINSTALL_ERROR]: 'business.devices.profiles.v2.errors.ADDON_UNINSTALL_ERROR',
  [DeviceProfileMessageStatuses.INCOMPATIBLE_PROFILE_TYPE]: 'business.devices.profiles.v2.errors.ERROR',
  [DeviceProfileMessageStatuses.MODE_DELETE_ERROR]: 'business.devices.modes.toastMessage.error.delete',
  [DeviceProfileMessageStatuses.MODE_DUPLICATE_ERROR]: 'business.devices.modes.toastMessage.error.duplicate',
  [DeviceProfileMessageStatuses.MODE_RECOMMENDED_TEMPLATES_ERROR]: 'business.devices.modes.toastMessage.error.mostRecommendedModeTemplates',
  [DeviceProfileMessageStatuses.MODE_SEARCH_ERROR]: 'business.devices.modes.toastMessage.error.search'
};
export const DEFAULT_ERROR_MESSAGE_KEY = ERROR_STATUS_TRANSLATION_KEYS[DeviceProfileMessageStatuses.ERROR];

// Use when throwing an error is needed but there is no error to assign as the cause
export let DeviceProfileMessage = (_dec = computed('status'), _class = class DeviceProfileMessage extends Error {
  constructor(message, status) {
    super(message);
    _initializerDefineProperty(this, "status", _descriptor, this);
    this.status = status;
  }
  get displayTranslationKey() {
    if (!ERROR_STATUS_TRANSLATION_KEYS[this.status]) {
      captureException(`Unexpected error status: ${this.status}`);
      return DEFAULT_ERROR_MESSAGE_KEY;
    }
    return ERROR_STATUS_TRANSLATION_KEYS[this.status];
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "status", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "displayTranslationKey", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "displayTranslationKey"), _class.prototype), _class);
let DeviceProfileError = (_dec2 = computed('status'), _class3 = class DeviceProfileError extends Error {
  constructor(message, error, {
    status
  } = {}) {
    super(message);
    _initializerDefineProperty(this, "status", _descriptor2, this);
    _initializerDefineProperty(this, "cause", _descriptor3, this);
    _defineProperty(this, "getCause", cause => {
      if (cause instanceof DeviceProfileError) {
        return this.getCause(cause.cause);
      }
      if (cause instanceof Error) {
        return cause;
      }
      return null;
    });
    let localStatus = status;
    if (error instanceof DeviceProfileError || error instanceof DeviceProfileMessage) {
      // The UI expects errors to bubble up with their status intact to display appropriate toasts
      localStatus = error.status;
    }
    this.status = localStatus || DeviceProfileMessageStatuses.ERROR;
    this.cause = this.getCause(error);
  }
  get displayTranslationKey() {
    if (!ERROR_STATUS_TRANSLATION_KEYS[this.status]) {
      return DEFAULT_ERROR_MESSAGE_KEY;
    }
    return ERROR_STATUS_TRANSLATION_KEYS[this.status];
  }
}, _descriptor2 = _applyDecoratedDescriptor(_class3.prototype, "status", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "cause", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class3.prototype, "displayTranslationKey", [_dec2], Object.getOwnPropertyDescriptor(_class3.prototype, "displayTranslationKey"), _class3.prototype), _class3);
export { DeviceProfileError as default };